<template>
  <div class="profile page page-with-table p-3">
    <div class="content-wrapper">
      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-header">
              <h5 class="mb-0">
                {{ $t('My Profile') }}
              </h5>
            </div>
            <div class="card-body">
              <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
                <b-form @submit.prevent="handleSubmit(onUserFormSubmit)">
                  <div class="row">
                    <div class="col-md-6 border-right">
                      <div class="row">
                        <div class="col-md-6">
                          <input-widget :autofocus="true" :model="model" attribute="first_name"/>
                        </div>
                        <div class="col-md-6">
                          <input-widget :model="model" attribute="last_name"/>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <input-widget :autofocus="true" :model="model" attribute="email"/>
                        </div>
                        <div class="col-md-6" v-if="formattedUiLanguages && formattedUiLanguages.length > 1">
                          <input-widget :model="model"
                                        attribute="preferred_language"
                                        value-field="value"
                                        display-field="${item.key}"
                                        type="select2"
                                        :items="formattedUiLanguages"/>
                        </div>
                        <div class="col-md-6">
                          <input-widget :model="model"
                                        attribute="csv_export_delimiter"
                                        value-field="value"
                                        display-field="${item.key}"
                                        type="select2"
                                        :items="csvExportDelimiters"/>
                        </div>

                        <!--                    <div class="col-md-6">-->
                        <!--                      <input-widget :model="model" attribute="phone"/>-->
                        <!--                    </div>-->
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <input-widget type="password" :model="model" attribute="password" vid="password"/>
                        </div>
                        <div class="col-md-6">
                          <input-widget type="password" :model="model" attribute="repeat_password"
                                        vid="repeat_password"/>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="row">
                        <div class="col-md-6">
                          <country-select-input-widget attribute="country_code" :model="model"/>
                        </div>
                        <div class="col-md-6">
                          <input-widget :model="model" attribute="address_1"/>
                        </div>
                        <div class="col-md-6">
                          <input-widget :model="model" attribute="address_2"/>
                        </div>
                        <div class="col-md-6">
                          <input-widget :model="model" attribute="state"/>
                        </div>
                        <div class="col-md-6">
                          <input-widget :model="model" attribute="county"/>
                        </div>
                        <div class="col-md-6">
                          <input-widget :model="model" attribute="city"/>
                        </div>
                        <div class="col-md-6">
                          <input-widget :model="model" attribute="zip_code"/>
                        </div>
                        <div class="col-md-6">
                          <input-widget :model="model" attribute="phone"/>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-actions text-right">
                        <submit-button/>
                      </div>
                    </div>
                  </div>
                </b-form>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-6">

          <div class="card">
            <div class="card-header">
              <h5 class="mb-0">
                {{ $t('Trusted Devices') }}
              </h5>
            </div>
            <div class="card-body">
              <template v-if="trustedDevices.loading">
                <spinner show height="20" size="5"/>
              </template>
              <artisio-table :items="trustedDevices.rows" :checkboxes="false" :fields="trustedDevicesFields" v-else>
                <template slot="cell(created)" slot-scope="{item: device}">
                  {{ device.created | toDate }}
                </template>
                <template slot="cell(device)" slot-scope="{item: device}">
                  {{ device.device }}
                </template>
                <template slot="cell(expires_at)" slot-scope="{item: device}">
                  {{ device.expires_at | toDateTime }}
                </template>
                <template slot="cell(actions)" slot-scope="{item: device}">
                  <b-button variant="danger"
                            @click.prevent="deleteTrustedDevice(device)">
                    {{ $t('Remove Device') }}
                  </b-button>
                </template>
              </artisio-table>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="card">
            <div class="card-header">
              <h5 class="mb-0">
                {{ $t('Authenticator App') }}
              </h5>
            </div>
            <div class="card-body">
              <p>{{ $t("Get verification codes from the authenticator app. Even if you are offline.") }}</p>
              <div class="row" v-if="authenticatorCreated">
                <div class="col-lg-12">
                  {{ $t('Authenticator App was created at: ') }} {{ authenticatorCreated | toDate }}
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <b-button variant="primary" class="m2" @click.prevent="openAuthenticatorModal()">
                    {{ authenticatorCreated ? $t('Change Authenticator App') : $t('Add Authenticator App') }}
                  </b-button>
                  <b-button variant="danger" class="m-2" v-if="authenticatorCreated"
                            @click.prevent="removeAuthenticatorApp()">
                    {{ $t('Remove Authenticator App') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <authenticator-modal/>
  </div>
</template>

<script>

  import InputWidget from "../../../core/components/input-widget/InputWidget";
  import UserForm from "./UserForm.model";
  import SubmitButton from "../../../core/components/common/SubmitButton";

  import ProfileService from "./ProfileService";
  import {createNamespacedHelpers} from "vuex";
  import AuthenticatorModal from "@/modules/auth/Profile/AuthenticatorModal.vue";
  import Spinner from "@/core/components/common/Spinner.vue";
  import ArtisioTable from "@/core/components/ams-table/ArtisioTable.vue";
  import i18n from "@/shared/i18n";
  import CountrySelectInputWidget from "@/core/widgets/CountrySelectInputWidget";
  import i18nService from "@/core/services/i18n.service";

  const {mapState, mapActions} = createNamespacedHelpers('profile');
  const {mapState: mapStateGlobal, mapActions: mapActionsGlobal, mapGetters} = createNamespacedHelpers('global');

  export default {
    name: "Profile",
    components: {CountrySelectInputWidget, ArtisioTable, Spinner, AuthenticatorModal, SubmitButton, InputWidget},
    data() {
      return {
        model: new UserForm(),
        csvExportDelimiters: [
          {key: 'Comma (,)', value: ','},
          {key: 'Semicolon (;)', value: ';'},
          {key: 'Tab (↹)', value: 'tab'},
          {key: 'Pipe (|)', value: '|'},
          {key: 'Tilde (~)', value: '~'},
        ],
        trustedDevicesFields: [
          {
            "key": "created",
            "label": i18n.t("Created"),
            "sortable": false,
            "tdClass": "created-col",
            "expand": ""
          },
          {
            "key": "device",
            "label": i18n.t("Device"),
            "sortable": false,
            "tdClass": "device-col",
            "expand": ""
          },
          {
            "key": "expires_at",
            "label": i18n.t("Expires At"),
            "sortable": false,
            "tdClass": "expires-at-col",
            "expand": ""
          },
          {
            "key": "actions",
            "label": i18n.t("Actions"),
            "sortable": false,
            "tdClass": "actions-col",
            "expand": ""
          }
        ]
      }
    },
    computed: {
      ...mapStateGlobal({
        currentUser: state => state.currentUser
      }),
      ...mapState({
        authenticatorCreated: state => state.authenticatorCreated,
        trustedDevices: state => state.trustedDevices
      }),
      ...mapGetters(['formattedUiLanguages']),
    },
    methods: {
      ...mapActionsGlobal(['updateCurrentUser', 'updateAuthenticatorData']),
      ...mapActions(['getAuthenticatorData', 'openAuthenticatorModal', 'removeAuthenticator', 'getTrustedDevices', 'removeTrustedDevice']),
      async onUserFormSubmit() {
        this.model.resetErrors();

        let response = await ProfileService.updateUserData(this.currentUser.uuid, this.model);

        if (response.success) {
          this.updateCurrentUser(response.body);
          this.$toast('success', this.$t('User data was successfully saved'));

          let currentLang = i18nService.getLanguage()
          if (currentLang !== this.model.preferred_language) {
            setTimeout(() => {
              i18nService.setLanguage(this.model.preferred_language, true)
            }, 500)
          }

        } else {
          this.model.setMultipleErrors(response.body);
          this.$toast('danger', this.$t('Could not save user data'));
        }

      },
      async removeAuthenticatorApp() {
        const success = await this.$confirm(this.$i18n.t("Are you sure you want to remove Authenticator app?"));
        if (!success) {
          return;
        }
        const response = await this.removeAuthenticator();
        if (response.success) {
          this.getAuthenticatorData();
          this.$toast('success', this.$i18n.t('Successfully removed authenticator app.'));
        } else {
          this.$toast('danger', this.$i18n.t('Unable to remove authenticator app. Please try again.'));
        }
      },
      async deleteTrustedDevice(device) {
        const success = await this.$confirm(this.$i18n.t("Are you sure you want to remove this device: '{device}'?", {device: device.device}));
        if (!success) {
          return;
        }
        const response = await this.removeTrustedDevice(device.uuid);
        if (response.success) {
          this.getTrustedDevices();
          this.$toast('success', this.$i18n.t('Successfully removed device.'));
        } else {
          this.$toast('danger', this.$i18n.t('Unable to remove device. Please try again.'));
        }
      }
    },
    mounted() {
      this.model = new UserForm({
        first_name: this.currentUser.first_name,
        last_name: this.currentUser.last_name,
        email: this.currentUser.email,
        phone: this.currentUser.phone,
        preferred_language: this.currentUser.preferred_language,
        csv_export_delimiter: this.currentUser.csv_export_delimiter,
        address_1: this.currentUser.address_1,
        address_2: this.currentUser.address_2,
        city: this.currentUser.city,
        state: this.currentUser.state,
        county: this.currentUser.county,
        zip_code: this.currentUser.zip_code,
        country_code: this.currentUser.country_code,
      });
      this.getAuthenticatorData();
      this.getTrustedDevices();
    }
  }
</script>

<style scoped>

</style>
